import React, { useState } from "react";
import PropTypes from "prop-types";
import cx from "classnames";
import { InfoPanel as InfoPanelComponent } from "@sunwing/shared-components";
import { Profile } from "./Profile";
import { Row, Cell } from "../Grid";

import styles from "./InfoPanel.module.scss";

const InfoPanel = ({ members, profileClassnames, className, theme }) => {
	const [activeKey, setActiveKey] = useState(null);
	return (
		<Row cols={4} className={styles.relative}>
			{members.map(member => (
				<Cell key={member.id}>
					<InfoPanelComponent isActive={member.id === activeKey} className={styles.info}>
						<InfoPanelComponent.View>
							<Profile
								activeMember={member.id === activeKey && member.id}
								classNames={{
									...profileClassnames,
									profilePictureBackground: member.profile.customBackgroundClassName,
								}}
								id={member.id}
								image={member.profile.image}
								isActive={member.id === activeKey}
								name={member.profile?.name}
								// eslint-disable-next-line jsx-a11y/aria-role
								role={member.profile?.role}
								setKey={id => {
									setActiveKey(id);
								}}
								theme={theme}
								profileBackgroundColor={member.profile?.profileBackgroundColor}
							/>
						</InfoPanelComponent.View>
						<InfoPanelComponent.Info className={cx(styles?.container, styles[theme], className)}>
							{member.details}
						</InfoPanelComponent.Info>
					</InfoPanelComponent>
				</Cell>
			))}
		</Row>
	);
};
InfoPanel.propTypes = {
	members: PropTypes.arrayOf(
		PropTypes.shape({
			id: PropTypes.string,
			profile: PropTypes.shape({
				name: PropTypes.string.isRequired,
				role: PropTypes.string.isRequired,
				isActive: PropTypes.string,
				image: PropTypes.shape({
					className: PropTypes.string,
					wrapperClassName: PropTypes.string,
					src: PropTypes.string,
					source: PropTypes.shape({
						src: PropTypes.string,
						srcSet: PropTypes.string,
						sizes: PropTypes.string,
					}),
					alt: PropTypes.string,
					title: PropTypes.string,
					autoResponsive: PropTypes.bool,
					renderImage: PropTypes.func,
				}),
				customBackgroundClassName: PropTypes.string,
				profileBackgroundColor: PropTypes.string,
			}),
			details: PropTypes.node.isRequired,
		})
	).isRequired,
	profileClassnames: PropTypes.shape({
		profile: PropTypes.string,
		profileActive: PropTypes.string,
		profilePicture: PropTypes.string,
		profilePictureBackground: PropTypes.string,
		profileImgWrapper: PropTypes.string,
		profileInfo: PropTypes.string,
		btnIcon: PropTypes.string,
		btnIconActive: PropTypes.string,
	}),
	className: PropTypes.string,
	theme: PropTypes.oneOf(["primary", "wedding"]),
};

InfoPanel.defaultProps = {
	profileClassnames: undefined,
	className: undefined,
	theme: "primary",
};

export default InfoPanel;
export { InfoPanel };
